import React from 'react';
import { motion } from 'framer-motion';
import glob from "../assets/langglob.png"; // Update the path if necessary
import { FaLanguage } from 'react-icons/fa';

const LanguageSelection = ({setCurrentStep}) => {
    return (
        <motion.div
            className="flex flex-col items-center px-2 justify-start gap-6 max-w-2xl mx-auto  bg-[#191919] text-white "
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
        >
            {/* Multilingual Greeting */}
            <div className="mb-4 text-center">
                <p className="md:text-lg text-sm">
                    Welcome - Willkommen - Bonvenon - Bienvenido - Bienvenue - Välkommen - Selamat datang - Benvenuto - 欢迎 - Welkom - Bem Vindo - добро пожаловать
                </p>
            </div>

            {/* Globe image */}
            <div className="flex justify-center mb-8">
                <motion.img
                    src={glob} // Use your uploaded image path here
                    alt="Global Flags"
                    className="md:w-[320px] w-[240px] md:h-[320px] h-[240px] object-cover rounded-full"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.5 }}
                />
            </div>


            {/* Footer with language and version info */}
            <div className="flex flex-col items-center text-sm gap-5 w-full mt-8">
                <div className="flex items-center justify-between w-full gap-2 mb-2">
                   <div className='flex items-center gap-2'>
                   <span className="font-semibold"><FaLanguage size={30}/></span> <span>English (US)</span>
                   </div>
                    <motion.button
                        onClick={() => setCurrentStep(2)}
                        className="px-7 text-sm py-2.5 bg-orange-500 rounded-sm text-white font-semibold"
                        initial={{ scale: 0 }}
                        animate={{ scale: 1 }}
                        transition={{ duration: 0.3 }}
                    >
                        Continue
                    </motion.button>
                </div>
                <span>0.18.4.0-unknown (Qt 5.15.16)</span>
            </div>
        </motion.div>
    );
};

export default LanguageSelection;
